import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{attrs:{"dismissible":"","type":"error","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }